// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application"

// Eager load all controllers defined in the import map under controllers/**/*_controller
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })

// Register all controllers
Object.entries(controllers).forEach(([path, controller]) => {
  const name = path.match(/\.\/(.+)_controller\.js$/)[1]
  application.register(name, controller.default)
})
